(function () {
  function sync(item) {
    var data = item.querySelector('[data-hmc-upsell-variants]');
    var btn = item.querySelector('[data-hmc-upsell-add]');
    if (!data || !btn) return;
    var variants = JSON.parse(data.textContent);
    var chosen = Array.prototype.map.call(item.querySelectorAll('[data-hmc-upsell-opt]'), function (s) { return s.value; });
    var match = variants.filter(function (v) { return v.o.join('|') === chosen.join('|'); })[0];
    if (match && match.a) {
      btn.dataset.hmcUpsellAdd = match.id;
      btn.disabled = false;
      btn.textContent = 'Add';
    } else {
      btn.disabled = true;
      btn.textContent = 'Sold out';
    }
  }
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-hmc-upsell-opt]');
    if (sel) sync(sel.closest('.hx-upsell__item'));
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hmc-upsell-add]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.textContent = '...';
    var drawer = document.querySelector('cart-drawer');
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(btn.dataset.hmcUpsellAdd, 10), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status || !state.sections || !drawer || typeof drawer.renderContents !== 'function') {
          if (state.status) throw new Error(state.description || 'add failed');
          window.location.reload();
          return;
        }
        state.id = state.items && state.items[0] ? state.items[0].id : undefined;
        drawer.renderContents(state);
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Add'; });
  });
})();
